import { site } from "@/mocks/site";

export default function HotTicker() {
  const words = [...site.hotWords, ...site.hotWords];
  return (
    <section aria-label="热门搜索词" className="border-y border-background-200 bg-accent-100/70">
      <div className="mx-auto flex w-full items-center gap-5 px-4 py-3.5 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 font-label text-sm font-medium text-primary-700">
          <i className="ri-flashlight-fill text-base" aria-hidden="true"></i>
          正在热传
        </span>
        <div className="relative flex-1 overflow-hidden">
          <ul className="flex w-max animate-marquee items-center gap-8">
            {words.map((word, index) => (
              <li
                key={`${word}-${index}`}
                className="flex items-center gap-8 whitespace-nowrap font-label text-sm text-foreground-700"
              >
                {word}
                <span className="h-1 w-1 rounded-full bg-primary-400" aria-hidden="true"></span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}